import React, { useState, useRef } from "react"
import styles from "./Dashboard.module.scss"
import { UserInterface } from "../../App"
import Org from "../Org/Org"

const Dashboard: React.FC<{
    user: UserInterface
    setUser: React.Dispatch<React.SetStateAction<UserInterface>>
}> = ({ user, setUser }) => {
    // function to return good morning, afternoon, evening, or night based on the current time
    const getGreeting = () => {
        const hour = new Date().getHours()
        if (hour < 12) return "Good morning"
        if (hour < 18) return "Good afternoon"
        return "Good evening"
    }

    return (
        <div className={styles.Dashboard}>
            <div className={styles.header}>
                <div>
                    <h2>Dashboard</h2>
                    <h2 className={styles.greeting}>
                        {getGreeting()}, {user.name}.
                    </h2>
                </div>
                <div
                    className={styles.logout}
                    onClick={() => {
                        const confirmed = window.confirm(
                            "You are about to log out. Are you sure you want to continue?"
                        )

                        if (confirmed) {
                            localStorage.removeItem("credentials")
                            setUser({} as UserInterface)
                            window.location.href = "#/login"
                        }
                    }}>
                    <i className="material-symbols-rounded">logout</i>
                </div>
            </div>

            <Org user={user} setUser={setUser} />
        </div>
    )
}

export default Dashboard
